import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import RewardEntryPage from "./pages/Rewards/RewardEntryPage";
import ProtectedRoute from "./components/ProtectedRoute";

const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/reward-entry"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated()}>
              <RewardEntryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            isAuthenticated() ? (
              <Navigate to="/reward-entry" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
